<template>
  <span class="tag" :class="{ selected: isSelected }" @click="toggleSelect">
    {{ label }}
  </span>
</template>

<script setup>
import {
  defineEmits,
  defineProps,
} from 'vue';

const props = defineProps({
  label: { type: String, required: true },
  isSelected: { type: Boolean, default: false }
});

const emit = defineEmits(["toggle"]);

const toggleSelect = () => {
  emit("toggle", props.label);
};

</script>

<style scoped>
.tag {
  display: inline-block;
  padding: 6px 8px;
  border: 1px solid var(--constant-grey13);
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: var(--constant-grey);
  background-color: var(--constant-white);
  cursor: pointer;
  transition: all 0.2s ease;
}

.tag:hover {
  background-color: var(--constant-grey13);
  color: var(--constant-white);
}

.selected {
  background-color: var(--constant-grey13);
  color: var(--constant-white);
}

:root[scheme="dark"] .tag {
  border: 1px solid var(--constant-grey5);
  color: var( --constant-grey-light);
  background-color: var(--constant-black);
}

:root[scheme="dark"] .tag:hover {
  background-color: var(--constant-grey-light5);
  color: var(--constant-black);
}

:root[scheme="dark"] .selected {
  background-color: var(--constant-grey-light5);
  color: var(--constant-black);  
}
</style>